import React, { useState, useCallback } from 'react';
import {
  required, minLength, maxLength, minValue, maxValue,
  number, regex, email, choices,
  Edit,
  SimpleForm,
  TextInput,
  NumberInput, useNotify, useRedirect,
  ReferenceInput,
  SelectInput, DateField, AutocompleteInput,
  FormDataConsumer, ReferenceField, useRefresh,
  DateInput, ReferenceManyField, Datagrid, TextField,
  BooleanInput, TabbedForm, FormTab,
} from "react-admin";
import { FormToolbar } from "../../common/FormToolbar";
import { StateDistrict } from "./StateDistrict";
import { useStyles } from "../../formStyles";
import Button from '@material-ui/core/Button';
import CDeleteButton from "../../common/CDeleteButton";
import { makeStyles } from '@material-ui/core/styles';
import { Drawer } from '@material-ui/core';
import RealizationOtherDocumentsCreate from "./RealizationOtherDocumentsCreate";
import RealizationDocumentsCreate from "./RealizationDocumentsCreate";
import * as apiClient from "../../common/apiClient";
import RealizationDocumentEdit from "./RealizationDocumentEdit";
import { RealizationOrderPatmentFields } from "./RealizationOrderPatmentFields";
import { RealizationOrderOtherFields } from "./RealizationOrderOtherFields";
import { RealizationPrint } from "./RealizationPrint";
import { PrintTPAChecklist } from "./PrintTPAChecklist";

import CorporateCreate from './CorporateCreate'
import AddIcon from '@material-ui/icons/Add';
import  DispatchFields  from './DispatchFields';
const myStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  list: {
    flexGrow: 1,
    transition: theme.transitions.create(['all'], {
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: 0,
  },
  listWithDrawer: {
    marginRight: 300,
  },
  drawerPaper: {
    zIndex: 100,
    marginTop: 50,
    width: 850,
  },
}));

const DisplayFileLink = (props) => {
  let { record } = props;

  if (record.docUrl && record.docUrl.length > 0)
    return (
      <a href={record.docUrl}>View File</a>
    )
  else {
    return null
  }
}

const UploadDocument = (props) => {
  let { record } = props;
  return (
    <div className="upload-document" onClick={() => {
      props.onClick(record);
    }}>Edit Document</div>
  )
}

const DeleteDocumentButton = (props) => {
  let { record } = props;
  return (
    <input type="checkbox" onChange={(e) => {
      props.onSelectedDocument(record);
    }} />
  )
}

export const RealizeOrderEdit = (props) => {

  let propsObj = { ...props };
  if (propsObj.permissions) {
    let resourcename = `/${props.resource}`;
    let myPermissions = propsObj.permissions.filter(item => item.NavigateUrl.toLowerCase().trim() == resourcename);
    if (myPermissions.length > 0) {
      let p = myPermissions[0];
      propsObj.hasList = (p.View == 1) ? true : false;
      propsObj.hasShow = (p.View == 1) ? false : false;
      propsObj.hasEdit = (p.Edit == 1) ? true : false;
      propsObj.hasDelete = (p.Delete == 1) ? true : false;
      propsObj.hasCreate = (p.Create == 1) ? true : false;
      propsObj.hasExport = (p.Export == 1) ? true : false;
    }
  }
  let isAdmin = false;
  let RoleTypeId = localStorage.getItem("RoleTypeId"); 
  if(RoleTypeId != null && RoleTypeId == "1"){
    isAdmin = true;
  }
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();
  const classes = useStyles({});
  const myclasses = myStyles({});
  const [isaddDocuments, setIsAddDocuments] = useState(false);
  const [isEditDocuments, setIsEditDocuments] = useState(false);
  const [isEditDocumentRecord, setIsEditDocumentRecord] = useState(0);
  const [isaddOtherDocuments, setIsAddOtherDocuments] = useState(false);
  const [isAddCorportate, setIsAddCorportate] = useState(false);
  const [selectedDocumentsId, setSelectedDocumentsId] = useState<any[]>([]);
  const [isPrint, setPrint] = useState(false);
  const [isPrintTPA, setPrintTPA] = useState(false);
  const [tpaId, setTPAID] = useState(0);
  const [configValue, setConfigValue] = useState(0);

  const SelectDeselectDocument = (record) => {
    var ids: any[] = [...selectedDocumentsId];
    const id: any = record.id;
    const index = ids.indexOf(id);
    if (index > -1) {
      ids.splice(index, 1);
    } else {
      ids.push(id);
    }
    setSelectedDocumentsId(ids);
  }
  const onDocumentDelete = async () => {
    var ids: any[] = [...selectedDocumentsId];
    if (ids.length == 0) {
      alert("Please select some documents.");
      return;
    }
    var cn = window.confirm("Are you sure you want to delete the selected documents?");
    if (!cn)
      return;
    ids.forEach(async item => {
      await apiClient.deleteRealizationDocument(item);
    });
    refresh();
  }

  const addFromSetup = (id) => {
    if (configValue == 0) {
      alert("Please select the config.");
      return;
    }

    apiClient.addFromSetup(id, configValue).then(res => {
      refresh();
    }).catch(err => {
      console.log(err);
    });
  }
  const onCloseDocumentForm = () => {
    setIsAddDocuments(false);
    setIsEditDocuments(false);
    setPrint(false);
    setPrintTPA(false);
    refresh();
  }
  const Print = (id) => {
    setPrint(true);
  }
  const PrintTPA = (id) => {
    
    setPrintTPA(true);
  }
  const onCloseOtherDocumentForm = () => {
    setIsAddOtherDocuments(false);
    refresh();
  }
  const onCancel = () => {
    setIsAddDocuments(false);
    setIsAddOtherDocuments(false);
    setIsEditDocuments(false);
    setIsAddCorportate(false);
    setPrint(false);
    setPrintTPA(false);
    
  }
  const handleClose = useCallback(() => {
    setIsAddDocuments(false);
    setIsAddOtherDocuments(false);
    setIsEditDocuments(false);
    setPrint(false);
    setIsAddCorportate(false);
  }, []);
  const redirectMe = (basePath, id, data) => {
    console.log(basePath);
    console.log(id);
    console.log(data);
  };
  const validateUserCreation = (values) => {
    const errors: any = {};
    //console.log(values);
    if (values.uDisAllAmt > 0 && values.rpriotiyId == 14) {
      errors.rpriotiyId = ["Please Change the Recl. Priority"];
    }
    return errors
  };
  return (
    <React.Fragment>
      <Edit title="Realize Order Edit"

        {...propsObj} undoable={false}>
        <TabbedForm
          validate={validateUserCreation}
          redirect={false} variant="outlined" toolbar={<FormToolbar {...propsObj} showDelete={false} />}>
          <FormTab label="Basic Details">
            <TextInput validate={[required(), minLength(3)]} source="billNo" label="Record No" fullWidth={true} formClassName={classes.one_4_input} />
            <TextInput validate={[required(), minLength(3)]} source="hBillNo" label="Hospital Bill No" fullWidth={true} formClassName={classes.two_4_input} />

            <TextInput validate={[required(), minLength(3)]} source="pName" label="Patient Name" fullWidth={true} formClassName={classes.three_4_input} />
            <TextInput validate={[required(), minLength(3)]} source="pMobNo" label="Mobile  Number" fullWidth={true} formClassName={classes.last_4_input} />


            <TextInput source="pEmail" label="Patient e-Mail" fullWidth={true} formClassName={classes.one_4_input} />
            <ReferenceInput perPage={25} sort={{ field: 'name', order: 'ASC' }}  validate={[required()]} 
              filterToQuery={searchText => ({ 'name~like': searchText })}
              label="Hospital Name" source="hospitalId" reference="hospitals" fullWidth={true} formClassName={classes.two_4_input}>
              <AutocompleteInput optionText="name" shouldRenderSuggestions={(val) => { return val && val.trim().length >= 1 }} />
            </ReferenceInput>

            <DateInput validate={[required()]} label="DOA" source="doa" fullWidth={true} formClassName={classes.three_4_input} />
            <DateInput validate={[required()]} label="DOD" source="dod" fullWidth={true} formClassName={classes.last_4_input} />

            <TextInput validate={[required(), minLength(3)]} label="Card No" source="cardNo" fullWidth={true} formClassName={classes.one_4_input} />
            <TextInput disabled={isAdmin ? false : true} validate={[required(), minLength(3)]} label="CCN No" source="ccnno" fullWidth={true} formClassName={classes.two_4_input} />

            <TextInput validate={[required(), minLength(3)]} source="policyNo" fullWidth={true} formClassName={classes.three_4_input} />
            <ReferenceInput
              perPage={25} sort={{ field: 'name', order: 'ASC' }}
              filterToQuery={searchText => ({ 'name~like': searchText })}
              validate={[required()]} label="TPA Name" source="tpaId" reference="tpas" fullWidth={true} formClassName={classes.last_4_input}>
              <AutocompleteInput optionText="name" shouldRenderSuggestions={(val) => { return val && val.trim().length >= 1 }} />
            </ReferenceInput>

            <ReferenceInput
              perPage={25} sort={{ field: 'name', order: 'ASC' }}
              filterToQuery={searchText => ({ 'name~like': searchText })}
              validate={[required()]} label="Insurer Name" source="insurerId" reference="insurers" fullWidth={true} formClassName={classes.first_inline_input}>
              <AutocompleteInput optionText="name" shouldRenderSuggestions={(val) => { return val && val.trim().length >= 1 }} />
            </ReferenceInput>
            {/* <ReferenceInput
              perPage={25} sort={{ field: 'name', order: 'ASC' }}
              filterToQuery={searchText => ({ 'name~like': searchText })}
              label="Corporate Name" source="corporateId" reference="corporates" fullWidth={true} formClassName={classes.last_inline_input}>
              <AutocompleteInput optionText="name" shouldRenderSuggestions={(val) => { return val && val.trim().length >= 1 }} />
            </ReferenceInput> */}
            <FormDataConsumer formClassName={classes.last_inline_input}>
              {formDataProps => (
                <div style={{ display: "flex", flex: "rows" }}>
                  <ReferenceInput perPage={25} sort={{ field: 'name', order: 'ASC' }}
                    filterToQuery={searchText => ({ 'name~like': searchText })}
                    label="Corporate Name" source="corporateId" reference="corporates" fullWidth={true} formClassName={classes.last_inline_input}>
                    <AutocompleteInput optionText="name" variant="outlined" shouldRenderSuggestions={(val) => { return val && val.trim().length >= 1 }} />
                  </ReferenceInput>
                  <Button onClick={() => { setIsAddCorportate(true) }}   ><AddIcon /></Button>
                </div>
              )}
            </FormDataConsumer>

            <DateInput validate={[required()]} label="Received At HDC" source="frecDate" fullWidth={true} formClassName={classes.one_4_input} />
            <DateInput label="Soft File Sub. Date" source="fVSubDate" fullWidth={true} formClassName={classes.two_4_input} />
            <DateInput label="Phy File Sub Date" source="fSubDate" fullWidth={true} formClassName={classes.three_4_input} />

            <ReferenceInput
              perPage={500} sort={{ field: 'name', order: 'ASC' }}
              label="Status" source="statusId" reference="lookups" formClassName={classes.last_4_input}
              filter={{ type: 'RO' }} fullWidth={true} >
              <SelectInput optionText="name" />
            </ReferenceInput>

            <FormDataConsumer>
              {formDataProps => (
                <RealizationOrderPatmentFields {...formDataProps} />
              )}
            </FormDataConsumer>

            <FormDataConsumer>
              {formDataProps => (
                <RealizationOrderOtherFields {...formDataProps} />
              )}
            </FormDataConsumer>

          </FormTab>

          <FormTab label="Forwarding Documents">
            <div style={{ flex: 1, width: "50%" }}>
              <Button onClick={() => { setIsAddDocuments(true); }}>Add New</Button>
              <Button onClick={() => { addFromSetup(props.id); }}>Add From Setup</Button>
              <ReferenceInput variant="outlined" onChange={(e) => { setConfigValue(e.target.value); }}
                sort={{ field: 'mconame', order: 'ASC' }}
                label="Setup Config" source="configId" reference="configs" formClassName={classes.first_inline_input} fullWidth={true} >
                <SelectInput optionText="mconame" />
              </ReferenceInput>
              <div>
                
              
                <Button onClick={() => { Print(props.id); }}>Print Dispatch Checklist</Button>
                {<Button onClick={() => { onDocumentDelete(); }}>Delete Selected Documents</Button>}
              </div>
            </div>

            <ReferenceManyField fullWidth={true}
              addLabel={false}
              sort={{ field: 'id', order: 'ASC' }}
              reference="realiz-ord-dets"
              target="realizordId">
              <Datagrid>
                {/* <CDeleteButton {...props} /> */}
                {<DeleteDocumentButton label="Delete" onSelectedDocument={(record) => {
                  //console.log(record);
                  SelectDeselectDocument(record);
                }} />}
                {/* <TextField label="ITP" source="itp" />
                <TextField label="BillNo" source="billNo" /> */}
                <DateField showTime={true} label="Entry Date" source="entryDt" locales="fr-FR"  />
                <TextField label="Document Type" source="docType" />
                <TextField label="Document Value" source="docValue" />
                <DisplayFileLink label="Document URL" source="docUrl" />
                <UploadDocument onClick={(record) => { setIsEditDocumentRecord(record); setIsEditDocuments(true); }} label="Upload Document" />
              </Datagrid>
            </ReferenceManyField>
          </FormTab>
          <FormTab label="Other Documents">
            
          
               
            {/* <FormDataConsumer>
              {formDataProps => (
                <DispatchFields {...formDataProps} />
              )}
            </FormDataConsumer> */}
            <FormDataConsumer fullwidth={true}>
              {formDataProps => (
                <DispatchFields {...formDataProps} />
              )}
            </FormDataConsumer>

          {/* <DateInput label="Despatched Date/ delivery date" source="deliveryDate" fullWidth={true} formClassName={classes.one_4_input} /> */}
          <FormDataConsumer>
              {formDataProps => ( setTPAID((formDataProps.formData.tpaId)) 
              )}
            </FormDataConsumer>
            <div style={{ flex: 1 }}>
              <Button style={{marginRight:"10"}}  onClick={() => { setIsAddOtherDocuments(true); }}>Add New Document</Button>
               {(tpaId===12 ||  tpaId===15)?  <Button onClick={() => { PrintTPA(props.id); }}>Print TPA Declaration</Button>:null}
            </div>
            <ReferenceManyField fullWidth={true}
              addLabel={false}
              sort={{ field: 'id', order: 'ASC' }}
              reference="realiz-ord-docs"
              target="realizOrdId">
              <Datagrid>
                {isAdmin && <CDeleteButton {...props} />}
                <ReferenceField label="Document Type" source="typeId"
                  filter={{ type: 'DT' }}
                  reference="lookups" link={false}>
                  <TextField source="name" />
                </ReferenceField>
                <TextField label="Remarks" source="remarks" />
                <DisplayFileLink label="Document URL" source="docUrl" />
                <DateField showTime={true} label="Entry Date" source="createdDate"  locales="fr-FR" />
              </Datagrid>
            </ReferenceManyField>
          </FormTab>
        </TabbedForm>
      </Edit >
      <Drawer
        anchor="right"
        onClose={handleClose}
        classes={{
          paper: myclasses.drawerPaper,
        }}
        open={isaddDocuments || isaddOtherDocuments || isEditDocuments || isPrint || isAddCorportate || isPrintTPA} >

        {isaddOtherDocuments && <RealizationOtherDocumentsCreate
          onClose={onCloseOtherDocumentForm}
          onCancel={onCancel}
          realizOrdId={props.id}
          {...props} />}
        {isaddDocuments && <RealizationDocumentsCreate
          onClose={onCloseDocumentForm}
          onCancel={onCancel}
          realizOrdId={props.id}
          {...props} />}
        {isEditDocuments && <RealizationDocumentEdit
          onClose={onCloseDocumentForm}
          onCancel={onCancel}
          record={isEditDocumentRecord}
          {...props} />}
        {isPrint && <RealizationPrint
          onClose={onCloseDocumentForm}
          onCancel={onCancel}
          realizOrdId={props.id}
          {...props} />}
          {isPrintTPA && <PrintTPAChecklist 
          tpaId={tpaId}
          onClose={onCloseDocumentForm}
          onCancel={onCancel}
          realizOrdId={props.id}
          {...props} />}
        {isAddCorportate && <CorporateCreate onClose={handleClose} />}
      </Drawer>
    </React.Fragment>
  );
};
